import React from "react";

import { kpiDefinitions } from "../model/defaults";
import { formatKpi } from "../model/format";
import { getCombinedTarget } from "../model/targets";
import {
  AggregatedTotals,
  AllocationLabels,
  KpiAllocation,
  KpiKey,
  MarketTarget,
} from "../model/types";
import AllocationMix from "./AllocationMix";
import ValueWithTarget from "./ValueWithTarget";

interface KpiGridProps {
  kpis: KpiKey[];
  totals: AggregatedTotals;
  allocation: KpiAllocation;
  allocationLabels: AllocationLabels;
  targets: MarketTarget[];
  /** Selected periods and the Market filter, the two axes a target combines across. */
  periods: string[];
  marketFilter: string[];
}

const TARGET_METRICS: KpiKey[] = ["revenue", "profit"];

export default function KpiGrid(props: KpiGridProps) {
  const {
    kpis,
    totals,
    allocation,
    allocationLabels,
    targets,
    periods,
    marketFilter,
  } = props;

  return (
    <>
      <div className="finance-reporting-allocation-legend">
        <strong>Allocation type</strong>
        <span>
          <i className="finance-reporting-allocation__ad-date" />{" "}
          {allocationLabels.reportingDate}
        </span>
        <span>
          <i className="finance-reporting-allocation__budget-month" />{" "}
          {allocationLabels.budgetMonth}
        </span>
      </div>
      <div className="finance-reporting-kpis">
        {kpis.map((key) => {
          const definition = kpiDefinitions.find((kpi) => kpi.key === key);
          if (!definition) return null;

          const target = TARGET_METRICS.includes(key)
            ? getCombinedTarget(
                targets,
                periods,
                marketFilter,
                key as "revenue" | "profit",
              )
            : null;

          return (
            <article key={key} className="finance-reporting-kpi">
              <span className="finance-reporting-kpi__label">
                {definition.label}
              </span>
              <strong className="finance-reporting-kpi__value">
                <ValueWithTarget
                  value={totals[key]}
                  target={target}
                  format={(value) => formatKpi(key, value)}
                  className="finance-reporting-kpi__target"
                />
              </strong>
              <AllocationMix
                split={allocation[key]}
                metric={key}
                labels={allocationLabels}
                target={target}
              />
            </article>
          );
        })}
      </div>
    </>
  );
}
